module.exports = __webpack_public_path__ + "img/ambulance-night.c3bd0611.jpg";